
import Vue from "vue";

export default Vue.extend({
  name: "Profile",

  computed: {
    user() {
      return this.$store.getters["user/info"];
    },
  },

  methods: {
    getUserAvatar() {
      return this.user.avatar.url;
    },
    async logout() {
      try {
        await this.$store.dispatch("authentication/logout");
        await this.$router.push("/auth/login");
      } catch (e) {
        await this.$store.dispatch("alerts/showError", e.message);
      }
    },
    parseUsername() {
      if (this.user && this.user.first_name && this.user.last_name) {
        return [this.user.last_name, this.user.first_name]
          .map(([item]: any) => item)
          .slice(0, 2)
          .join("")
          .toUpperCase();
      }
      return "";
    },
  },
});
